<template>
  <div class="experience">
    <div class="experience-info">
      <template v-if="!hiddenTitle">
        <div
          v-if="hasValue(['company', 'university', 'title', 'name'])"
          class="title"
        >
          {{
            experience.company ||
            experience.university ||
            experience.title ||
            experience.name
          }}
        </div>
        <div v-if="hasValue(['title', 'major'])" class="sub-title">
          {{ experience.title || experience.major }}
        </div>
      </template>
      <template v-if="hasValue(['description'])">
        <el-tooltip
          placement="left-start"
          :popper-class="`experience-description-popper ${personInfo.theme}`"
          :effect="personInfo.theme"
        >
          <div
            slot="content"
            class="description-full"
            v-html="experience.description"
          ></div>
          <div class="description" v-html="experience.description"></div>
        </el-tooltip>
      </template>
    </div>
    <div class="time flex justify-between items-center">
      <span v-if="experience.updated_at">
        更新时间：{{ experience.updated_at | formatTime }}
      </span>
      <CompleteButton
        style="border-radius: 18px; font-size: 14px; font-weight: 500"
        text="点击复制"
        @clickBtn="copyExperience"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
import CompleteButton from "../CompleteButton/CompleteButton.vue";
import { copyToClipboard } from "@/assets/js/util";
export default {
  name: "ExperienceItem",
  components: {
    CompleteButton,
  },
  props: {
    experience: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    hiddenTitle: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    formatTime(time) {
      return moment(time).format("YYYY-MM-DD");
    },
  },
  computed: {
    ...mapState("me", ["personInfo"]),
  },
  methods: {
    hasValue(keys) {
      return keys.some((key) => this.experience[key]);
    },
    async copyExperience() {
      await copyToClipboard(
        this.experience.description.replace(/<\/?[\s\S]*?>/g, "")
      );
      this.$message.success("复制成功");
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/css/variable.scss";
.experience {
  color: $text-color;
  margin-bottom: 10px;
  background-color: $form-bg-color;
  padding: 0 16px;
  border-radius: 8px;
  &:last-child {
    margin-bottom: 16px;
  }
  .experience-info {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px 0 16px;
    border-bottom: 1px dashed $experience-after-color;
    .title {
      font-size: 16px;
      line-height: 16px;
      font-weight: 500;
      margin-bottom: 4px;
    }
    // .sub-title {
    //   margin-bottom: 8px;
    // }
    .description {
      display: -webkit-box;
      /*将对象作为弹性伸缩盒子模型显示*/
      overflow: hidden;
      white-space: normal !important;
      text-overflow: ellipsis;
      word-wrap: break-word;
      -webkit-line-clamp: 2;
      /*限制在一个块元素显示的文本的行数*/
      -webkit-box-orient: vertical;
    }
  }
  .time {
    font-size: 12px;
    color: $experience-time;
    height: 62px;
  }
  .copy-btn {
    background: linear-gradient(270deg, #e15d3f 0%, #febf5d 100%);
    color: #fff;
  }
}
</style>
<style lang="scss">
@import "@/assets/css/variable.scss";
.experience-description-popper {
  padding: 0;
  border-radius: 8px;
  overflow: hidden;
  border: none !important;
  &.light {
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
  }
  .description-full {
    width: 300px;
    border-radius: 8px;
    padding: 20px 16px;
    font-size: 14px;
    line-height: 20px;
    background-color: $form-bg-color;
    color: $text-color;
  }
}
</style>
